import React from "react";


export default function CustomLoader() {
    return (
        <>
            <div className={"flex justify-center items-center h-full w-full"}>
                <div className={"animate-spin py-2 border-dashed rounded-full h-32 w-32 border-t-4 border-blue-500"}></div>
            </div>
        </>
    )
}